import React,{Component} from 'react';
import NavBar from './common/header/header.jsx'
import ScrollToTopButton from '../shared/scrollToTop.jsx';

export class LayoutContainer extends Component{
    render(){
        return(
            <>
                <NavBar />
                <div>
                    {this.props.children}
                </div>
                <ScrollToTopButton/>
            </>
        )
    }
}